import { connect } from 'react-redux';
import { getCertDesignName } from '../store/certificate/selectors';
import { setCertDesign } from '../store/certificate/slice';
import withMobile from '../hocs/withMobile';
import DesignSelector from '../components/DesignSelector';

const mapStateToProps = (state) => ({
  design: getCertDesignName(state),
});

const mapDispatchToProps = (dispatch) => ({
  setDesign: (payload) => dispatch(setCertDesign(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(DesignSelector));
